import { BrandTypes } from '@ps/platform-message-framework/common/BrandTypes';
import { Sites } from '@ps/platform-message-framework/common/Sites';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import BrandLogoVegas from '@swf/core/assets/pokerstars-vegas.svg';
import { select } from '@swf/core/store';

import BrandLogoCasino from '../../../../../assets/brand-logo-casino.svg';
import BrandLogoPoker from '../../../../../assets/brand-logo-poker.svg';
import BrandLogoSport from '../../../../../assets/brand-logo-sports.svg';

import styles from './BrandLogo.scss';

const BrandLogo: React.FC = () => {
  const brand = useSelector(select.cms.getBrandId);
  const siteId = useSelector(select.cms.getSiteId);

  const logo = useMemo(() => {
    switch (true) {
      case siteId === Sites.DE:
        return BrandLogoVegas;
      case brand === BrandTypes.STARS_CASINO:
        return BrandLogoCasino;
      case brand === BrandTypes.POKER_STARS:
        return BrandLogoPoker;
      case brand === BrandTypes.BET_STARS:
        return BrandLogoSport;
      default:
        return BrandLogoPoker;
    }
  }, [brand, siteId]);

  return React.createElement(logo, { className: styles.logo });
};

export default BrandLogo;
